import script from "./ActiveParentAccountAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActiveParentAccountAmount.vue?vue&type=script&setup=true&lang=ts"

import "./ActiveParentAccountAmount.vue?vue&type=style&index=0&id=09e3a9df&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e3a9df"]])

export default __exports__